import { render, staticRenderFns } from "./pentest.vue?vue&type=template&id=3b452ba4"
import script from "./pentest.vue?vue&type=script&lang=js"
export * from "./pentest.vue?vue&type=script&lang=js"
import style0 from "./pentest.vue?vue&type=style&index=0&id=3b452ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports